/* eslint-disable */
import React, { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, createTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import Dialog from '@material-ui/core/Dialog';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import AddIcon from '@material-ui/icons/Add';
import FullscreenLoader from './../../common/components/FullscreenLoader';
import moment from "moment-timezone";
import NotificationIcon from '../../common/components/NotificationIcon';
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Grid from '@material-ui/core/Grid';
import Paper from "@material-ui/core/Paper";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { getNewBrand } from '../../common/components/util';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from '@material-ui/icons/Search';
import { getMaterialGroups } from '../../store/actions/materialGroups.actions';
import Tooltip from '@material-ui/core/Tooltip';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import WarningIcon from "@material-ui/icons/Warning";
import DialogContentText from '@material-ui/core/DialogContentText';
import { addNewStockRule, deleteStockRule, getManageStock } from '../../store/actions/dealer.action';
import AddNewRuleDialog from './AddNewRuleDialog';
import { getTBLPartsAPI } from '../../store/actions/createUpdateEnquiry.actions';
import _, { get } from "lodash";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    actionButton: {
        color: '#1A9FE0',
    },
    tableCell: {
        backgroundColor: 'transparent',
    },
    actionButtonTable: {
        padding: 4,       // or even 0 if needed
        marginRight: 8,
        color: '#00AEEF', // match your icon color
    },
    yes: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#1A9FE0',
        textTransform: 'capitalize'
    },
    addUpdateDailogTitle: {
        position: "absolute",
        top: 10,
        left: 10
    },
    icon: {
        float: "left",
        margin: "0 20px 20px 0",
        height: "100%",
        fill: "white",
    },
    cancel: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#919191',
        textTransform: 'capitalize'
    },
    menuItem: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 12,
        paddingRight: 12,
        minHeight: '32px',
    },
    logoutText: {
        color: '#616161',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'inherit',
        textAlign: 'left',        // <-- key change
        lineHeight: '1.6',
        paddingLeft: '8px'        // <-- ensures alignment under the icon
    },
    iconButton: {
        padding: 10,
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    visuallyHidden: {
        border: 0,
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,

    },
    title: {
        flex: '1 1 100%',
        fontSize: 30,
    },
    button: {
        borderRadius: "1.25rem",
        minWidth: 170,
        margin: "0 0 0 .5%",
        backgroundColor: "#1A9FE0",
        color: "white",
        height: "2.25rem",
        fontSize: "0.7rem",

    },
    inCellButton: {
        color: '#1A9FE0',
        textTransform: 'none',
        fontSize: 12,
        padding: "0 0.9rem",
    },
    header: {
        color: "#133F8A",
        fontWeight: 900,
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        textAlign: 'left',
        minWidth: 90,
        maxWidth: 120
    },
    subHeader: {
        backgroundColor: '#fafafa',
        fontWeight: 500,
        fontSize: '13px',
        color: '#666',
        textAlign: 'center',
        borderBottom: '1px solid #e0e0e0',
    },
    bodyContent: {
        color: '#666666',
        fontWeight: 600,
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
    },
    closeButton: {
        backgroundColor: '#EAEAEA',
        width: 140,
        fontWeight: 800,
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#666666',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 24
    },
    bodyContentActionHeader: {
        color: "#133F8A",
        fontWeight: 900,
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        textAlign: 'left',
        maxWidth: 60
    },
    bodyContentAction: {
        maxWidth: 60
    },
}));
const theme = createTheme({
    palette: {
        secondary: {
            main: '#1A9FE0'
        },
    }
});

export default function ManageStock() {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const rowsPerPage = 10;
    const dispatch: Dispatch<any> = useDispatch();
    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [searchText, setSearchText] = React.useState<any>('');
    const { getManageStockData }: any = useSelector((state: any) => state.dealer);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isEdit, setIsEdit] = React.useState(false);
    const [selectedPartNumber, setSelectedPartNumber] = React.useState<any>('');
    const [openDialog, setOpenDialog] = React.useState<any>(false);
    const [loading, setLoading] = React.useState<any>(false);
    const [selectedStockItem, setSelectedStockItem] = React.useState<{
        partNumber: string;
        brand: string;
        orgId: string;
        stockPercentage: number;
    } | null>(null);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
    const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
    const userName = get(profileDetails, 'data.data.basicInfo.displayName', "");

    useEffect(() => {
        dispatch(getMaterialGroups());
        dispatch(getTBLPartsAPI());
    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>, partNumber: string) => {
        const foundItem = getManageStockData?.data?.data?.data?.stockData?.find(
            (item: any) => item.partNumber === partNumber
        );
        setSelectedRow(foundItem); // so Menu has access
        setAnchorEl(event.currentTarget);
    };

    const handleCloseAnchor = () => {
        setAnchorEl(null);
    };

    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };

    const handleopenCloseSnackbar = (open?: any) => {
        setOpenSnackbar(open ? true : false);
    };

    const handleopenCloseErrorSnackbar = (open?: any) => {
        setOpenErrorSnackbar(open ? true : false);
    };

    useEffect(() => {
        if (searchText === "") {
            dispatch(getManageStock(0, rowsPerPage, ""));
        }
    }, [searchText, dispatch]);

    const handleSearch = async (pageNumber: number) => {
        setPage(pageNumber);
        const filter = searchText.length >= 3 ? searchText : "";
        const data: any = await dispatch(getManageStock(pageNumber * 10, rowsPerPage, filter));
        if (data?.error) {
            setSuccessMessage(data.error);
            handleopenCloseErrorSnackbar(true);
        }
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        handleSearch(newPage);
    };

    const handleEditOrDelete = (item: any) => {
        setSelectedStockItem({
            partNumber: item.partNumber,
            brand: item.brand,
            orgId: item.orgId,
            stockPercentage: item.stockPercentage,
        });
    };

    const deleteManageStockRule = async () => {
        if (!selectedStockItem) return;

        setLoading(true);

        const payload = {
            partNumber: selectedStockItem.partNumber,
            brand: selectedStockItem.brand,
            orgId: selectedStockItem.orgId,
            updatedBy: userName,
            stockPercentage: 0, // ✅ Always zero on delete
        };

        const responseData: any = await dispatch(addNewStockRule(payload));
        if (responseData && responseData.status === 400) {
            setShowErrorMessage(responseData && responseData.error);
            handleopenCloseErrorSnackbar(true);
            handleopenCloseSnackbar(false);
            setLoading(false);
        } else {
            setLoading(false);
            setSuccessMessage("Rule deleted successfully.");
            handleopenCloseSnackbar(true);
            setOpenDialog(false); // ✅ close dialog
            dispatch(getManageStock(0, rowsPerPage, ""));
            dispatch(getTBLPartsAPI());
        }
    };

    return (
        <div className={classes.root}>
            {loading && <FullscreenLoader />}
            <Snackbar
                open={openSnackbar}
                message={successMessage}
                handleopenClose={() => {
                    handleopenCloseSnackbar(false)
                }} />
            <Snackbar
                open={openErrorSnackbar}
                type="error"
                message={showErrorMessage}
                handleopenClose={() => {
                    handleopenCloseErrorSnackbar(false)
                }} />
            {getManageStockData && getManageStockData.loading && <FullscreenLoader />}
            <div className="d-flex align-items-center">
                <h2 className="page-title">
                    Stock Update</h2>
                <div className="ml-auto">
                    {/* <AnnouncementIcon /> */}
                    <NotificationIcon />
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <div className="d-flex align-items-center mb-2">
                        <p className="dealer-table-title-parts-list">List of all Updated Stock</p>
                        <div className="row-space-start ml-auto pr-4">
                            <Button
                                variant="contained"
                                color="secondary"
                                className="createFavourite ml-2"
                                startIcon={<AddIcon />}
                                // disabled
                                size="large"
                                onClick={() => {
                                    setIsEdit(false);
                                    handleClickOpen();
                                }}
                            >
                                Add New Rule
                            </Button>
                            <div className='px-2'></div>
                            <Tooltip title="Enter at least 3 characters to search." placement="top">
                                <TextField
                                    placeholder="Search by Part No."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" && searchText.length >= 3) {
                                            handleSearch(0);
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        if (searchText.length >= 3) {
                                                            handleSearch(0);
                                                        }
                                                    }}
                                                    disabled={searchText.length < 3}
                                                    size="small"
                                                >
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    className="pill-search-input"
                                />
                            </Tooltip>
                        </div>
                    </div>
                    <div className="cardCommon mh-300p">
                        <Grid item xs={12} className="mt-2 cardCommon">
                            <TableContainer component={Paper} className="height-500">
                                <Table aria-label="dealer table">
                                    {/* ──────────────── HEADER ──────────────── */}
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ width: 190, paddingLeft: 16 }}>
                                                <div className="dealer-table-title pt-1 px-1">Part Number</div>
                                                <div className="dealer-table-title-desc pt-3 pb-2"></div>
                                            </TableCell>
                                            <TableCell style={{ width: 130 }}>
                                                <div className="dealer-table-title pt-1">Brand</div>
                                                <div className="dealer-table-title-desc pt-3 pb-2"></div>
                                            </TableCell>
                                            <TableCell style={{ width: 130 }}>
                                                <div className="dealer-table-title pt-1">SOH</div>
                                                <div className="dealer-table-title-desc pt-3 pb-2"></div>
                                            </TableCell>
                                            <TableCell style={{ width: 140 }}>
                                                <div className="dealer-table-title pt-1">Updated Stock</div>
                                                <div className="dealer-table-title-desc pt-3 pb-2"></div>
                                            </TableCell>
                                            <TableCell style={{ width: 160 }}>
                                                <div style={{ display: "flex", flexDirection: "column", whiteSpace: "nowrap" }}>
                                                    <div
                                                        className="mb-2 pt-1"
                                                        style={{ color: "#133F8A", fontSize: "0.80rem", fontWeight: 700, fontFamily: "Nunito" }}
                                                    >
                                                        Updated By
                                                    </div>
                                                    <div className="dealer-table-title-desc pt-0 pb-0">KAM</div>
                                                </div>
                                            </TableCell>
                                            <TableCell style={{ width: 160 }}>
                                                <div style={{ display: "flex", flexDirection: "column", whiteSpace: "nowrap" }}>
                                                    <div
                                                        className="mb-2 pt-1"
                                                        style={{ color: "#133F8A", fontSize: "0.80rem", fontWeight: 700, fontFamily: "Nunito" }}
                                                    >
                                                        Updated On
                                                    </div>
                                                    <div className="dealer-table-title-desc pt-0 pb-0">Time</div>
                                                </div>
                                            </TableCell>
                                            <TableCell style={{ width: 80, textAlign: "center" }}>
                                                <div className="dealer-table-title mb-2 pt-1">Action</div>
                                                <div className="dealer-table-title-desc pt-2 pb-1"></div>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    {/* ──────────────── BODY ──────────────── */}
                                    <TableBody>
                                        {getManageStockData?.data?.data?.data?.stockData?.map((item: any, index: number) => (
                                            <TableRow key={index}>
                                                <TableCell style={{ width: 190, paddingLeft: 19 }}>
                                                    <div className="dealer-table-content">{item.partNumber ?? "-"}</div>
                                                </TableCell>
                                                <TableCell style={{ width: 130 }}>
                                                    <div className="dealer-table-content">
                                                        {item.brand ? getNewBrand(item.brand) : "-"}
                                                    </div>
                                                </TableCell>
                                                <TableCell style={{ width: 130 }}>
                                                    <div className="dealer-table-content">
                                                        {item.soh ? item.soh : "-"}
                                                    </div>
                                                </TableCell>
                                                <TableCell style={{ width: 140 }}>
                                                    <div className="dealer-table-content px-4">
                                                        {item?.stockPercentage != null ? `-${Math.abs(item.stockPercentage)}%` : "-"}
                                                    </div>
                                                </TableCell>
                                                <TableCell style={{ width: 160 }}>
                                                    <div className="dealer-table-content">{item.updatedBy}</div>
                                                </TableCell>
                                                <TableCell style={{ width: 160 }}>
                                                    <div className="dealer-table-content">
                                                        {item.updatedOn
                                                            ? moment(item.updatedOn, "DD-MM-YYYY hh:mm A").format("DD/MM/YYYY")
                                                            : "-"}
                                                    </div>
                                                    <div className="dealer-table-subcontent pt-1">
                                                        {item.updatedOn
                                                            ? moment(item.updatedOn, "DD-MM-YYYY hh:mm A").format("hh:mm A")
                                                            : "-"}
                                                    </div>
                                                </TableCell>
                                                <TableCell style={{ width: 80, textAlign: "center" }}>
                                                    <IconButton
                                                        onClick={(event: any) => handleClick(event, item.partNumber)}
                                                        className={classes.actionButton}
                                                        // disabled
                                                        size="small"
                                                    >
                                                        <div className="px-2 pt-1 pb-1 boxshadow-icon">
                                                            <MoreVertIcon fontSize="inherit" className={classes.actionButton} />
                                                        </div>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                {getManageStockData?.data?.data?.data?.stockData?.length === 0 && (
                                    <div className="my-5 mx-auto text-center">
                                        No data found.
                                    </div>
                                )}
                                {/* ──────────────── PAGINATION ──────────────── */}
                                <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 32, paddingBottom: 16 }}>
                                    <TablePagination
                                        rowsPerPageOptions={[rowsPerPage]}
                                        component="div"
                                        count={getManageStockData?.data?.data?.data?.count ?? 0}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                    />
                                </div>
                            </TableContainer>
                        </Grid>

                        {/* ──────────────── MENU (ACTION ⋮) ──────────────── */}
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseAnchor}
                            keepMounted
                            anchorReference="anchorEl"
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            className="mt-5 px-2"
                        >
                            <MenuItem className="px-3">
                                <Button
                                    className="text-info px-2"
                                    startIcon={<EditOutlinedIcon />}
                                    onClick={async () => {
                                        handleEditOrDelete(selectedRow); // ✅ Add this
                                        setIsEdit(true);
                                        handleClickOpen();
                                        handleCloseAnchor();
                                    }}
                                >
                                    <div className="font-dropdown">Edit</div>
                                </Button>
                            </MenuItem>

                            <MenuItem>
                                <Button
                                    className="text-info px-2"
                                    startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                                    onClick={() => {
                                        handleEditOrDelete(selectedRow); // ✅ Add this
                                        setOpenDialog(true);
                                        handleCloseAnchor();
                                    }}
                                >
                                    <div className="font-dropdown">Delete</div>
                                </Button>
                            </MenuItem>
                        </Menu>
                    </div>
                </div>
            </div>
            <React.Fragment>
                <Dialog
                    disableBackdropClick={true}
                    open={openDialog}
                    fullWidth={true}
                    maxWidth={'sm'}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent className='mt-2'>
                        <div className={`mt-2 ${classes.icon}`}>
                            <WarningIcon className="delete-warning" fontSize="small" />
                        </div>
                        <div>
                            <DialogContentText id="alert-dialog-description">
                                <div className="shift-to-party-page-title">
                                    Confirm Delete
                                </div>
                                <div className={`mt-2 ${classes.logoutText}`}>
                                    <p className="text-note-delete mt-2 px-5 same-font">
                                        Are you sure you want to delete the Rule?
                                    </p>
                                    <p className="mt-1 px-5 blue-note">
                                        Note: Deleting the rule will not delete the TBL Part.
                                    </p>
                                </div>
                            </DialogContentText>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <>
                            <Button
                                variant="contained"
                                className="border-left rounded-pill w-150p mt-2 mb-3"
                                color="primary"
                                onClick={async () => {
                                    deleteManageStockRule();
                                }}
                            >
                                Confirm
                            </Button>
                            <Button
                                variant="contained"
                                className={`mt-2 mb-3 ${classes.closeButton}`}
                                onClick={() => {
                                    setOpenDialog(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </>
                    </DialogActions>
                </Dialog>

            </React.Fragment>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleClose()
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                className="createFavoriteDialog"
                maxWidth="md"
            >
                <AddNewRuleDialog setOpenDialog={handleClose} isEdit={isEdit} handleSearch={handleSearch} selectedStockItem={selectedStockItem} />
            </Dialog>
        </div>
    );
}
